import * as constants from '.';

export const monthsArray = [
    constants.JANUARY_TEXT,
    constants.FEBRUARY_TEXT,
    constants.MARCH_TEXT,
    constants.APRIL_TEXT,
    constants.MAY_TEXT,
    constants.JUNE_TEXT,
    constants.JULY_TEXT,
    constants.AUGUST_TEXT,
    constants.SEPTEMBER_TEXT,
    constants.OCTOBER_TEXT,
    constants.NOVEMBER_TEXT,
    constants.DECEMBER_TEXT,
];

export const maxDay = [1, -2, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1].map(v => v + 30);

export const monthsOptions = monthsArray.map((month, key) => ({
    key,
    text: month,
    value: key + 1,
}));


// WEBPACK FOOTER //
// ./src/constants/customers.js